import { render, staticRenderFns } from "./FaqCategoryList.vue?vue&type=template&id=6b9c9820&scoped=true"
import script from "./FaqCategoryList.vue?vue&type=script&lang=js"
export * from "./FaqCategoryList.vue?vue&type=script&lang=js"
import style0 from "./FaqCategoryList.vue?vue&type=style&index=0&id=6b9c9820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c9820",
  null
  
)

export default component.exports